var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "ct-input-element ct-check-input" }, [
    _c("div", { staticClass: "ct-title ct-v-align" }, [
      !_vm.isRequired
        ? _c("label", { attrs: { for: _vm.inputFieldId } }, [
            _vm._v(_vm._s(_vm.label))
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.isRequired
        ? _c("label", { attrs: { for: _vm.inputFieldId } }, [
            _vm._v(_vm._s(_vm.label) + "*")
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "i",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.hasHint,
              expression: "hasHint"
            }
          ],
          staticClass: "material-icons",
          attrs: {
            "data-toggle": "tooltip",
            "data-placement": "bottom",
            title: _vm.$t(_vm.getHint),
            "data-original-title": _vm.$t(_vm.getHint)
          }
        },
        [_vm._v("help_outline")]
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "ct-content", class: { "has-error": _vm.hasError } },
      [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.hasPrefix,
                expression: "hasPrefix"
              }
            ]
          },
          [
            _c("p", { staticClass: "form-control-static" }, [
              _vm._v(
                "\n                " + _vm._s(_vm.prefix) + "\n            "
              )
            ])
          ]
        ),
        _vm._v(" "),
        _c("div", [
          _c("div", [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.iModel,
                  expression: "iModel"
                }
              ],
              staticClass: "form-control",
              attrs: { id: _vm.inputFieldId, type: "text" },
              domProps: { value: _vm.iModel },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.iModel = $event.target.value
                }
              }
            })
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.hasSuffix,
                expression: "hasSuffix"
              }
            ]
          },
          [
            _c("p", { staticClass: "form-control-static" }, [
              _vm._v(
                "\n                " + _vm._s(_vm.suffix) + "\n            "
              )
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.hasIcon,
                expression: "hasIcon"
              }
            ],
            staticClass: "ct-v-align",
            class: _vm.iconClass
          },
          [
            _c("i", { staticClass: "material-icons" }, [
              _vm._v(_vm._s(_vm.checkIcon))
            ])
          ]
        )
      ]
    ),
    _vm._v(" "),
    _c("div", { class: { "has-error": _vm.hasError } }, [
      _c(
        "span",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.hasError,
              expression: "hasError"
            }
          ],
          staticClass: "help-block"
        },
        [_vm._v(_vm._s(_vm.getError))]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-810f34f4", { render: render, staticRenderFns: staticRenderFns })
  }
}